"use client";

import { useCallback } from "react";
import { DEFAULT_STOCK_NOT_FOUND_IMG_URL } from "../ClpStockCards/clpCardConstant";
import { RecentlyViewedGrid } from "./RecentlyViewedGrid";
import {
  RECENTLY_VIEWED_CONTENT_DEFAULTS,
  RECENTLY_VIEWED_DEFAULT_SECTION_TITLE,
  RecentlyViewedStockItem,
} from "./recentlyViewedTypes";
import {
  recentlyViewedTrackAnalytics,
  trackRecentlyViewedClick,
} from "./recentlyViewedAnalytics";

interface RecentlyViewedClientProps {
  stocks: RecentlyViewedStockItem[];
  isLoading?: boolean;
  errorMessage?: string;
  stockNotFoundImgUrl?: string;
  modalTitle?: string;
  modalBtnCta?: string;
  successMsg?: string;
  errorMsg?: string;
  sectionTitle?: string;
  componentPosition?: string;
}

export const RecentlyViewedClient = ({
  stocks,
  isLoading = false,
  errorMessage = RECENTLY_VIEWED_CONTENT_DEFAULTS.errorMessage,
  stockNotFoundImgUrl = DEFAULT_STOCK_NOT_FOUND_IMG_URL,
  modalTitle = RECENTLY_VIEWED_CONTENT_DEFAULTS.modalTitle,
  modalBtnCta = RECENTLY_VIEWED_CONTENT_DEFAULTS.modalBtnCta,
  successMsg = RECENTLY_VIEWED_CONTENT_DEFAULTS.successMsg,
  errorMsg = RECENTLY_VIEWED_CONTENT_DEFAULTS.errorMsg,
  sectionTitle = RECENTLY_VIEWED_DEFAULT_SECTION_TITLE,
  componentPosition,
}: RecentlyViewedClientProps) => {
  const handleCardClick = useCallback(
    (stock: RecentlyViewedStockItem, position: string) => {
      void trackRecentlyViewedClick({
        clickType: recentlyViewedTrackAnalytics.clickTypes.cardClick,
        sectionTitle,
        ctaText: stock.symbol,
        destinationUrl: stock.redirectURL ? `/${stock.redirectURL}` : undefined,
        componentPosition,
        tabPosition: position,
      });
    },
    [componentPosition, sectionTitle],
  );

  const handleCarouselClick = useCallback(
    (direction: "left" | "right") => {
      void trackRecentlyViewedClick({
        clickType: recentlyViewedTrackAnalytics.clickTypes.carouselClick,
        sectionTitle,
        ctaText: direction,
        componentPosition,
      });
    },
    [componentPosition, sectionTitle],
  );

  return (
    <RecentlyViewedGrid
      stocks={stocks}
      isLoading={isLoading}
      errorMessage={errorMessage}
      stockNotFoundImgUrl={stockNotFoundImgUrl}
      modalTitle={modalTitle}
      modalBtnCta={modalBtnCta}
      successMsg={successMsg}
      errorMsg={errorMsg}
      nextArrowClassName="!right-0"
      onCardClick={handleCardClick}
      onCarouselClick={handleCarouselClick}
    />
  );
};
